export function AssetUpload() {
  return (
    <v-btn>
      <v-icon>mdi-upload-outline</v-icon>
    </v-btn>
  );
}

export function CreateAsset() {
  return (
    <v-btn>
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  );
}

export function SelectTag() {
  return (
    <v-btn>
      <v-icon>mdi-tag-search-outline</v-icon>
    </v-btn>
  );
}

import SectionHelp from '../templates/SectionHelp.mdx';

# Assets Page

This page is where you can Add, Remove, Edit or Delete your assets

<SectionHelp />

## Upload an Asset

Click the <AssetUpload /> button (top left) to upload an Asset.

## Add a Live Stream, Video Feed, NDI, Text or JSON Asset

Click the <createAsset /> button (top left) to add a Live Stream.

## Search

If you start typing here, only the items that match your search terms will be shown.

## Select Tag

Click the <SelectTag /> button (top right). If you select a Tag here, this should only show Tags that have been selected.

{/* Editor note: **This is currently broken, or I misunderstand how this works**. */}
